import { render, staticRenderFns } from "./DeliveryLooseWidget.vue?vue&type=template&id=48b1e5a0&"
import script from "./DeliveryLooseWidget.vue?vue&type=script&lang=js&"
export * from "./DeliveryLooseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports